export default __webpack_public_path__ + "static/media/About-Tower-viajes-0.1c970415.jpg";